import { Component, OnInit, OnDestroy } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { Router, NavigationStart } from '@angular/router';
import { SortService } from '@app/components/sorting/SortService';
import { Subscription } from 'rxjs';
import { ClaimsService } from '@app/services/claims/claims.service';
import { Enumroles } from '@app/models/enumroles.enum';
import { ActivatedRoute } from '@angular/router';
import { FeeService } from '@app/services/fees/fee.service';

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

@Component({
  selector: 'app-handlememberfees',
  templateUrl: './handlememberfees.component.html'
})

export class HandlememberfeesComponent implements OnInit, OnDestroy {
  
  institutionform;
  isClerk = false;
  isSysAdmin = false;
  isFinancialOfficerCamp = false;
  financeinstitutions: number[] = [];
  baseinfo;
  currentinstitution;
  institutionslist: LodgeAndCamp[] = [];
  institution: LodgeAndCamp;
  link = null;
  subscriptions: Subscription[] = [];
  currentYear = new Date().getFullYear();
  years: number[] = [];
  selectedyear: number;
  viewyear = false;
  hidecontent = false;
  feelist;
  maxYear;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private feeService: FeeService,
    private institutionsService: InstitutionsService,
    private router: Router,
    private claimsService: ClaimsService) {
    this.subscriptions.push(this.router.events.pipe().subscribe((event: NavigationStart) => {
      if (event instanceof NavigationStart && event.url === '/medlemsavgifter') {
        this.resetView();
      }
    }));
  }

  async ngOnInit() {
    this.institutionform = this.fb.group({
      institutionId: ['', Validators.required],
      year: ['', Validators.required]
    });
    
    this.route.params.subscribe(param => {
      this.institutionform.patchValue({ institutionId: param.id });
      this.institutionsService.getInstitutionByIdAsync(param.id).subscribe(i => {
        this.currentinstitution = i;
        const currentYear = new Date().getFullYear();
        
       // this.institutionform.get('year')?.setValue(currentYear.toString());
       // this.selectedyear = currentYear;
       
        this.getYears();
      });
    });

    this.subscriptions.push(this.claimsService.claims$.subscribe(data => {
      if (data) {
        this.baseinfo = data;
        this.getInstitutions();
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  getMax(arr, prop) {
    var max;
    for (var i = 0; i < arr.length; i++) {
      if (max == null || parseInt(arr[i][prop]) > parseInt(max[prop]))
        max = arr[i];
    }
    return max;
  }

  getYears() {
    this.years = [];
    this.subscriptions.push(this.feeService.getFees(this.currentinstitution.id).subscribe(response => {
      if (response) {
        this.feelist = response;
        this.maxYear = (this.getMax(this?.feelist, 'year')).year;
        const startYear = 1884;
        while (this.maxYear >= startYear) {
          this.years.push(this.maxYear--);
        }
        const maxYear = Math.max(...this.years);
        this.institutionform.get('year')?.setValue(maxYear);
        this.selectedyear = maxYear;
      }
    }));
  }

  resetView() {
    this.link = null;
    this.ngOnInit();
  }

  getFinanceInstitutions() {
    this.baseinfo.claimsList.forEach(element => {
      if (element.key === Enumroles.FINANCIAL_OFFICER_CAMP) {
        this.financeinstitutions.push(element.value.id);
      }
    });
    return this.financeinstitutions;
  }

  getInstitutions() {
    this.subscriptions.push(this.institutionsService.getInstitutions().subscribe(response => {
      response.forEach(element => {
        const inst = { id: element.id, shortName: element.shortName, name: element.name };
        this.institutionslist.push(inst);
      });

      this.institutionslist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });

      if (!this.isSysAdmin && !this.isClerk) {
        if (this.isFinancialOfficerCamp) {
          this.financeinstitutions = [];
          this.financeinstitutions = this.getFinanceInstitutions();
          this.institutionslist = this.institutionslist.filter(element => {
            return this.financeinstitutions.indexOf(element.id) !== -1;
          });
        }
      }
    }));
  }

  handleFees() {
    this.link = 'handleFees';
  }

  registerPayments() {
    this.link = 'registerPayments';
  }

  nedsattning() {
    this.link = 'nedsattning';
  }

  setInstitution(evt: any) {
    this.institution = this.institutionslist.find(({ id }) => id === Number(evt.target.value));
  }

  setYear(evt: any) {
    
    this.selectedyear = Number(evt.target.value);
  }

  setAction(evt: any) {
    this.getYears();
    const val = evt.target.value;
    if (!val) {
      this.viewyear = false;
    }
    switch (val) {
      case 'handleFees': {
        this.handleFees();
        this.viewyear = false;
        break;
      }
      case 'registerPayments': {
        this.registerPayments();
        this.viewyear = true;
        break;
      }
      case 'nedsattning': {
        this.nedsattning();
        this.viewyear = true;
        break;
      }
    }
  }

  hideContent(evt) {
    this.hidecontent = evt;
  }
}
